var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnderlineIcon = function SvgUnderlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.522 2.629c-12.593-.805-29.031.988-41.683 1.689-9.329.516-18.667 1.218-27.88 2.514-.223.031-.48.075-.76.122-.805.136-1.795.304-2.699.304a1.5 1.5 0 0 1 0-3c.637 0 1.227-.1 1.931-.22.338-.058.703-.12 1.11-.177 9.336-1.313 18.77-2.02 28.132-2.539C45.377.618 58.102.294 70.865 1.11c.697.045 1.728.131 2.573.205.425.038.808.072 1.084.098l.446.041a1.5 1.5 0 0 1 1.354 1.634c-.077.825.315-.063-.51-.14l.188.036c-.273-.025.943-.318.522-.355-.846-.074-1.343.042-2 0",
    clipRule: "evenodd"
  })));
};
export default SvgUnderlineIcon;